module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-success--container"
  }, [_c('section', {
    staticClass: "p-success--container__information"
  }, [(this.items) ? _c('BoxNotification', {
    attrs: {
      "notificationState": 'success',
      "hideCloseButton": this.hideCloseButton
    }
  }, [_c('p', {
    staticClass: "m-boxNotification__Message",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [(_vm.isPendingSubscription) ? [_c('span', {
    staticClass: "m-boxNotification__Message--Bold"
  }, [_vm._v("Success")]), _vm._v(" - Thanks for your order - We've added a pending "), _c('span', {
    staticClass: "m-boxNotification__Message__Product"
  }, [_vm._v(_vm._s(_vm.productNames))]), _vm._v(" to your account. A confirmation email will be sent to "), _c('span', {
    staticClass: "m-boxNotification__Message--Bold"
  }, [_vm._v(_vm._s(_vm.emailAddress))]), _vm._v(" once your prepaid credit is used up and your subscription begins.\n        ")] : [_c('span', {
    staticClass: "m-boxNotification__Message--Bold"
  }, [_vm._v("Success")]), _vm._v(" - Thanks for your purchase. We've added "), _c('span', {
    staticClass: "m-boxNotification__Message__Product"
  }, [_vm._v(_vm._s(_vm.productNames))]), _vm._v(" to your account. A confirmation email has been sent to "), _c('span', {
    staticClass: "m-boxNotification__Message--Bold"
  }, [_vm._v(_vm._s(_vm.emailAddress))])]], 2)]) : _vm._e(), _vm._v(" "), (_vm.doesUserAlreadyOwnThisLicense) ? _c('BoxNotification', {
    attrs: {
      "hideCloseButton": this.hideCloseButton,
      "notification-state": 'warning'
    }
  }, [_c('p', {
    staticClass: "m-boxNotification__Message",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_c('span', {
    staticClass: "m-boxNotification__Message--Bold"
  }, [_vm._v("Heads up")]), _vm._v(" - " + _vm._s(_vm.doesUserAlreadyOwnThisLicenseMessage) + ".\n        "), _c('span', {
    staticClass: "m-boxNotification__Message--Link"
  }, [_c('a', {
    attrs: {
      "href": "https://account.serato.com/#/subscriptions"
    }
  }, [_c('button', {
    staticClass: "a-Button--Small a-Button--notifications a-Button--notifications--warning"
  }, [_vm._v("Manage")])])])])]) : _vm._e(), _vm._v(" "), (this.productGetSteps) ? _c('BoxInfos', {
    attrs: {
      "steps": this.stepProduct.steps
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d73fe8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/pages/Success.vue
// module id = 525
// module chunks = 2